import type { ActiveTenantDto } from '@agent-platform/shared';
import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useMe } from '@/lib/queries';
import { EmptyState } from './empty-state';

export function RequireTenant({ children }: { children: (tenant: ActiveTenantDto) => ReactNode }) {
  const me = useMe();
  const tenant = me.activeTenant;
  if (!tenant) {
    return (
      <EmptyState title="No tenant selected">
        {me.user.isSuperAdmin ? (
          <>
            Open a tenant from the{' '}
            <Link to="/platform/tenants" className="underline">
              Tenants
            </Link>{' '}
            page.
          </>
        ) : (
          'You are not a member of any tenant yet. Ask a tenant owner to invite you.'
        )}
      </EmptyState>
    );
  }
  if (tenant.status === 'suspended' && !me.user.isSuperAdmin) {
    return (
      <EmptyState title="Tenant suspended">
        This tenant is suspended. Contact your platform administrator.
      </EmptyState>
    );
  }
  return <>{children(tenant)}</>;
}
